

































































import { UserModule } from '@/store/modules/user'
import { Component, Prop, Vue } from 'vue-property-decorator'
import SmoothReflow from '@/components/_transitions/SmoothReflow.vue'
import { getBoUrl } from '@/api/http-constants'
import { getOperationID } from '@/api/operations'
import { nickname } from '@/utils/nickname'
import Avatar from '@/components/Profil/Avatar.vue'

@Component({
    components: {
        SmoothReflow,
        Avatar,
    },
})
export default class Menu extends Vue {
    userId: number
    nickname = ''
    imagePath: string | null = null
    windowHeight = 0
    windowWidth = 0
    footerHeight = 0
    footerHeightVisible = 0
    realMenuHeight = 0
    menuTop = 0
    membres: string[] = []

    async created() {
        if (UserModule.token == undefined) {
            UserModule.Init()
        }
        this.userId = UserModule.userInfos.id
        const p = UserModule.userInfos.imagePath
        this.imagePath = p ? getBoUrl() + p : null
        this.nickname = nickname(
            UserModule.userInfos.firstname,
            UserModule.userInfos.lastname
        )
    }

    get isProfil() {
        return ['foyer', 'appart', 'my-project'].indexOf(this.$route.name) > -1
    }

    /**
     * Caclul de la hauteur du menu
     */
    mounted() {
        window.addEventListener('resize', this.computeWindowSize)
        window.addEventListener('resize', this.computeFooterHeightVisible)
        window.addEventListener('scroll', this.computeFooterHeightVisible)
        this.computeWindowSize()
        this.computeFooterHeightVisible()

        const footer = document.body.querySelector('footer')
        this.footerHeight = footer.offsetHeight

        const menu = <HTMLElement>this.$refs.menu
        const menuRect = menu.getBoundingClientRect()
        const top = menuRect.top
        this.menuTop = top
    }

    destroyed() {
        window.removeEventListener('resize', this.computeWindowSize)
        window.removeEventListener('resize', this.computeFooterHeightVisible)
        window.removeEventListener('scroll', this.computeFooterHeightVisible)
    }

    computeWindowSize() {
        this.windowHeight = window.innerHeight
        this.windowWidth = window.innerWidth
    }

    computeFooterHeightVisible() {
        const bottomSpace =
            document.body.offsetHeight - (window.innerHeight + window.scrollY)
        this.footerHeightVisible = Math.max(this.footerHeight - bottomSpace, 0)
    }

    get menuHeight() {
        const menuHeight =
            this.windowHeight - this.menuTop - this.footerHeightVisible - 20
        if (this.windowWidth >= 992) {
            return menuHeight + 'px'
        } else {
            return 'auto'
        }
    }
}
